// Job-fit checker (cv.html#fit): a recruiter pastes a job ad and sees which
// of its technologies are in Abdelilah's CV, with where he used them. Plain
// pattern matching in the browser: instant, and the ad never leaves the page.
import { HAS, CLOSE, MISSING, SAMPLE } from "./fit-data.js";

const found = (list, text) => list.filter((item) => item.find.some((re) => re.test(text)));

// "3+ years", "2-4 years", "5 ans d'expérience": the smallest number asked for
function yearsAsked(text) {
  const m = text.match(/(\d{1,2})\s*(?:\+|-\s*\d{1,2}|à\s*\d{1,2}|to\s*\d{1,2})?\s*(?:years?|yrs|ans|années)/i);
  return m ? Number(m[1]) : 0;
}

export function analyze(text) {
  return {
    has: found(HAS, text),
    close: found(CLOSE, text),
    missing: found(MISSING, text),
    years: yearsAsked(text),
  };
}

const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);

function render(r) {
  const total = r.has.length + r.close.length + r.missing.length;
  if (!total) {
    return `<p class="fit__empty">No technologies recognised in this text. Paste the requirements part of the job ad.</p>`;
  }
  const row = (mark, name, note) =>
    `<li class="fit__row fit__row--${mark}"><span class="fit__mark" aria-hidden="true"></span><b>${esc(name)}</b><span>${esc(note)}</span></li>`;
  const years =
    r.years >= 2
      ? `<p class="fit__note">The ad asks for ${r.years}+ years. Abdelilah is early in his career: an internship at HPS and freelance work since 2025, plus two years of intensive project-based training.</p>`
      : "";
  return `
    <p class="fit__score"><b>${r.has.length}</b> of ${total} in his CV${r.close.length ? `, <b>${r.close.length}</b> close` : ""}</p>
    <ul class="fit__list">
      ${r.has.map((s) => row("has", s.name, s.proof)).join("")}
      ${r.close.map((s) => row("close", s.name, `close: ${s.near}`)).join("")}
      ${r.missing.map((s) => row("missing", s.name, "not in his CV")).join("")}
    </ul>
    ${years}
    <p class="fit__cta">Looks like a match? <a href="mailto:bouchikhiabdelilah0@gmail.com?subject=${encodeURIComponent("A role for you")}">Email Abdelilah</a></p>`;
}

// root: the page, or the CV panel on the home page (scripts/cv-sheet.js)
export default function initFit(root = document) {
  const form = root.querySelector("#fit-form");
  if (!form) return;
  const input = form.querySelector("textarea");
  const out = root.querySelector("#fit-result");
  const show = () => {
    const text = input.value.trim();
    out.innerHTML = text ? render(analyze(text)) : "";
  };
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    show();
  });
  form.querySelector("[data-sample]").addEventListener("click", () => {
    input.value = SAMPLE;
    show();
  });
}
